<template>
  <k-page class="page-points-starts-categories">
    <the-settings-points-categories />
  </k-page>
</template>

<script>
/**
 * Component: page-points-starts-categories - Страница настроек категорий акций
 *
 * @version 1.0.0
 */


// Components
import KPage from '@/components/KPage.vue';
import TheSettingsPointsCategories from '@/components/TheSettingsPointsCategories.vue';


export default {
  name: 'page-points-starts-categories',

  components: {
    KPage,
    TheSettingsPointsCategories,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-points-starts-categories {
  $this: &;
}
</style>
